import moment from 'moment-timezone'
import { takeLatest, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys, urlWithPrefix } from './helper'
import { httpPost, httpPut, httpGet, httpDelete, responseIsSuccess } from 'core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'
import { 
  bgCompanyRequestPath,
  bgCompanyReportEditPath
} from 'routes'

const createKeys = (key) => makeKeys(`BG_COMPANY_REQUEST_${key}`)

const GET_LIST = createKeys('GET_LIST')
const GET_DETAIL = createKeys('GET_DETAIL')
const GET_FLOW_DETAIL = createKeys('GET_FLOW_DETAIL')
const CREATE = createKeys('CREATE')
const UPDATE = createKeys('UPDATE')
const DELETE = createKeys('DELETE')
const RESUBMIT = createKeys('RESUBMIT')
const ACTION_FLOW = createKeys('ACTION_FLOW')


export const getBGCompanyRequest = makeAction(GET_LIST.REQUEST, 'query')
export const getBGCompanyRequestDetail = makeAction(GET_DETAIL.REQUEST, 'id')
export const getBGCRFlowDetail = makeAction(GET_FLOW_DETAIL.REQUEST, 'id')
export const createBGCompanyRequest = makeAction(CREATE.REQUEST, 'data', 'isSubmit', 'history')
export const updateBGCompanyRequest = makeAction(UPDATE.REQUEST, 'data', 'isSubmit', 'history')
export const deleteBGCompanyRequest = makeAction(DELETE.REQUEST, 'id', 'history')
export const resubmitBGCompanyRequest = makeAction(RESUBMIT.REQUEST, 'data', 'history')
export const actionBGCompanyRequest = makeAction(ACTION_FLOW.REQUEST, 'data', 'history')


const getBGCompanyRequestSuccess = makeAction(GET_LIST.SUCCESS, 'data')
const getBGCompanyRequestDetailSuccess = makeAction(GET_DETAIL.SUCCESS, 'data')
const getBGCRFlowDetailSuccess = makeAction(GET_FLOW_DETAIL.SUCCESS, 'data')


const apiPath = path => path ? urlWithPrefix(`bgcompanyrequest/${path}`) : urlWithPrefix('bgcompanyrequest')
const multipartHeader = { 'Content-Type': 'multipart/form-data', }

function* getBGCompanyRequestRequest(action) {
  const { query } = action.payload

  try {
    yield put(appLoading('Loading Bank Guarantee Company Request Data'))
    const response = yield httpGet(apiPath(), { ...query })
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(getBGCompanyRequestSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load Bank Guarantee Company Error!'))
    }
    yield put(getBGCompanyRequestSuccess([]))
  }
}

function* getBGCompanyRequestDetailRequest(action) {
  const { id } = action.payload

  try {
    yield put(appLoading('Loading Bank Guarantee Company Request Data'))
    const response = yield httpGet(apiPath(id))
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(getBGCompanyRequestDetailSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load Bank Guarantee Company Error!'))
    }
    yield put(getBGCompanyRequestDetailSuccess({}))
  }
}

function* getBGCRFlowDetailRequest(action) {
  const { id } = action.payload

  try {
    const response = yield httpGet(apiPath('workflowApproverViewMode'),{id:id})
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(getBGCRFlowDetailSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getBGCRFlowDetailSuccess([]))
  }
}

function* createBGCompanyRequestRequest(action) {
  const { data, isSubmit, history } = action.payload

  try {
    yield put(appLoading('Create bank guarantee company request.'))
    const response = yield httpPost(apiPath(), data)
    if (responseIsSuccess(response)) {
      const id = response.data
      var attachmentsData = {}
      if (data.bgc01) attachmentsData.bgc01 = data.bgc01
      if (data.bgc02) attachmentsData.bgc02 = data.bgc02
      if (data.bgc04) attachmentsData.bgc04 = data.bgc04

      if (Object.keys(attachmentsData).length) {
        yield put(appLoading('Upload attachment.'))
        yield httpPost(apiPath(`${id}/attachments`), attachmentsData, multipartHeader)
      }
      if (isSubmit) {
        yield put(appLoading('Submit bank guarantee company request.'))
        yield httpPut(apiPath(`${id}/submit`))
        yield put(appLoaded())
        yield put(toastSuccess('Update bank guarantee request success.'))
        history.push(bgCompanyRequestPath)
      } else {
        yield put(appLoaded())
        yield put(toastSuccess('Create bank guarantee request success.'))
        history.push(bgCompanyRequestPath)
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Create bank guarantee company error!'))
    }
  }
}

function* updateBGCompanyRequestRequest(action) {
  const { data, isSubmit, history } = action.payload

  try {
    yield put(appLoading('Update bank guarantee company request.'))
    //check attachment
    if(data.referenceDocumentType=='contract'){ //delete all file type BGC02
      data.attachments.filter(x=>x.documentCode=='BGC02').forEach((email, index) => {
        data.attachments[index].deleted = true;
      })
    }
    if(data.referenceDocumentType=='poNumber'){ //delete all file type BGC01
      data.attachments.filter(x=>x.documentCode=='BGC01').forEach((e, index) => {
        data.attachments[index].deleted = true;
      })
    }
    const response = yield httpPut(apiPath(data.id), data)
    if (responseIsSuccess(response)) {
      const id = response.data
      var attachmentsData = {}
      if (data.bgc01) attachmentsData.bgc01 = data.bgc01
      if (data.bgc02) attachmentsData.bgc02 = data.bgc02
      if (data.bgc04) attachmentsData.bgc04 = data.bgc04

      if (Object.keys(attachmentsData).length) {
        yield put(appLoading('Upload attachment.'))
        yield httpPost(apiPath(`${id}/attachments`), attachmentsData, multipartHeader)
      }
      if (isSubmit) {
        yield put(appLoading('Submit bank guarantee company request.'))
        yield httpPut(apiPath(`${id}/submit`))
        yield put(appLoaded())
        yield put(toastSuccess('Update bank guarantee request success.'))
        history.push(bgCompanyRequestPath)
      } else {
        yield put(appLoaded())
        yield put(toastSuccess('Update bank guarantee request success.'))
        history.push(bgCompanyRequestPath)
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update bank guarantee company error!'))
    }
  }
}

function* deleteBGCompanyRequestRequest(action) {
  const { id, history } = action.payload

  try {
    yield put(appLoading('Delete bank guarantee company request.'))
    const response = yield httpDelete(apiPath(id))
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      yield put(toastSuccess('Delete bank guarantee request success.'))
      history.push(bgCompanyRequestPath)
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Delete bank guarantee company error!'))
    }
  }
}

function* resubmitBGCompanyRequestRequest(action) {
  const { data, history } = action.payload

  try {
    yield put(appLoading('Update bank guarantee company request.'))
    //check attachment
    if(data.referenceDocumentType=='contract'){
      data.attachments.filter(x=>x.documentCode=='BGC02').forEach((email, index) => {
        data.attachments[index].deleted = true;
      })
    }
    if(data.referenceDocumentType=='poNumber'){
      data.attachments.filter(x=>x.documentCode=='BGC01').forEach((e, index) => {
        data.attachments[index].deleted = true;
      })
    }
    const response = yield httpPut(apiPath(data.id), data)
    if (responseIsSuccess(response)) {
      const id = response.data
      var attachmentsData = {}
      if (data.bgc01) attachmentsData.bgc01 = data.bgc01
      if (data.bgc02) attachmentsData.bgc02 = data.bgc02
      if (data.bgc04) attachmentsData.bgc04 = data.bgc04

      if (Object.keys(attachmentsData).length) {
        yield put(appLoading('Upload attachment.'))
        yield httpPost(apiPath(`${id}/attachments`), attachmentsData, multipartHeader)
      }
      yield put(appLoading('Resubmit bank guarantee company request.'))
      let dataResubmit = {
        docId:data.id,
        sn:data.sn,
        action:'Resubmit',
        comment:data.comment,
      }
      yield httpPost(apiPath(`${data.id}/action`), dataResubmit, multipartHeader)
      yield put(appLoaded())
      yield put(toastSuccess('Resubmit bank guarantee request success.'))
      history.push(bgCompanyRequestPath)
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Resubmit bank guarantee company error!'))
    }
  }
}

function* actionBGCompanyRequestRequest(action) {
  const { data, history } = action.payload

  try {
    yield put(appLoading('Action bank guarantee company request.'))
    //convert dateTime
    if(data.appointmentReceiveDate) data.appointmentReceiveDate = moment(data.appointmentReceiveDate).tz('Asia/Bangkok').format()
    if(data.receiveDate) data.receiveDate = moment(data.receiveDate).tz('Asia/Bangkok').format()
    const response = yield httpPost(apiPath(`${data.docId}/action`), data, multipartHeader)
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      yield put(toastSuccess('Action bank guarantee request success.'))
      if(response.data.key){ //new tab BGCompany Original when submit status Finance Processing
        window.open(bgCompanyReportEditPath(response.data.key))
      }
      history.replace(bgCompanyRequestPath)
      window.scrollTo(0,0)
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Action bank guarantee company error!'))
    }
  }
}

export function* watchBGCompanyRequestSaga() {
  yield takeLatest(GET_LIST.REQUEST, getBGCompanyRequestRequest)
  yield takeLatest(GET_DETAIL.REQUEST, getBGCompanyRequestDetailRequest)
  yield takeLatest(GET_FLOW_DETAIL.REQUEST, getBGCRFlowDetailRequest)
  yield takeLatest(CREATE.REQUEST, createBGCompanyRequestRequest)
  yield takeLatest(UPDATE.REQUEST, updateBGCompanyRequestRequest)
  yield takeLatest(DELETE.REQUEST, deleteBGCompanyRequestRequest)
  yield takeLatest(RESUBMIT.REQUEST, resubmitBGCompanyRequestRequest)
  yield takeLatest(ACTION_FLOW.REQUEST, actionBGCompanyRequestRequest)
}

const initial = {
  lists: { data: [], loading: false },
  detail: { data:{} },
  flowDetail: { data:[] }
}

export default createReducer(initial, state => ({
  [GET_LIST.REQUEST]: () => ({
    ...state,
    lists: { data: [], loading: true }
  }),
  [GET_LIST.SUCCESS]: (data) => ({
    ...state,
    lists: { data: data.data, loading: false }
  }),
  [GET_LIST.FAILURE]: (data) => ({
    ...state,
    lists: { data: [], loading: false }
  }),
  [GET_DETAIL.REQUEST]: () => ({
    ...state,
    detail: { data: {}, loading: true }
  }),
  [GET_DETAIL.SUCCESS]: (data) => ({
    ...state,
    detail: { data: data.data, loading: false }
  }),
  [GET_FLOW_DETAIL.REQUEST]: () => ({
    ...state,
    flowDetail: { data: [], loading: true }
  }),
  [GET_FLOW_DETAIL.SUCCESS]: (data) => ({
    ...state,
    flowDetail: { data: data.data, loading: false }
  }),
}))